export default class OrganizationsImportJob {
  constructor(API) {
    this.api = API;
  }
  /* CRUD */
  async createJob(jobObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organizations/importJob/new';
    req.body = { ...jobObj };
    return await req.exec();
  }
  async deleteJob(jobID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/organizations/importJob/' + jobID;
    return await req.exec();
  }
  async getJob(jobID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organizations/importJob/' + jobID;
    return await req.exec();
  }
  /* List */
  async getJobs() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organizations/importJobs';
    return await req.exec();
  }
  /* Operations */
  async startValidation(jobID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organizations/importJob/' + jobID + '/validate';
    return await req.exec();
  }
  async startImport(jobID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organizations/importJob/' + jobID + '/import';
    return await req.exec();
  }
  /* Logs */
  async getLogs(jobID, logLevel, isJSON) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organizations/importJob/' + jobID + '/logs' + (logLevel ? '?logLevel=' + logLevel : '');
    req.bodyType = 'JSON/BLOB';
    if (isJSON) {
      req.bodyType = 'JSON';
      req.appendHeader('Accept', 'application/json');
    } return await req.exec();
  }
}
